(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('PropertyDialogCommercialController', PropertyDialogCommercialController);

    PropertyDialogCommercialController.$inject = ['$timeout', '$scope', '$state', '$filter', 'entity', 'Property', 'MessageService','$uibModal', 'Qinius', 'UidService','Process'];

    function PropertyDialogCommercialController ($timeout, $scope, $state, $filter, entity, Property, MessageService,$uibModal, Qinius, UidService,Process ) {
        var vm = this;

        vm.domains = Qinius.getDomain();
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        vm.processOperationList = []
        vm.domains.$promise.then(function () {
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
        });
        vm.allTableList = []
        vm.delTableList = []
        loadAll();
        vm.showAddBtn = false

        function loadAll() {
            Process.query({
                page: 0,
                size: 20,
                // sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                var responseData = data.data || [];
                vm.processOperationList = responseData
                if(vm.property.process && vm.property.processOperationId){
                    vm.allTableList = responseData.find(function(item){
                        return item.id == vm.property.processOperationId
                    }).operationValues || []
                }
                var _propertyValues = vm.property.propertyValues.filter(function(itm){return !itm.cancelled})
                vm.delTableList = vm.property.propertyValues.filter(function(itm){return itm.cancelled})
                if(_propertyValues.length < vm.allTableList.length){
                    vm.showAddBtn = true
                }
            }

            function onError(error) {
            }
        }

        vm.property = entity.data;
        vm.title = "platformApp.property.edit"
        if(!vm.property.id){
            vm.property.propertyType = 'Default';
            vm.title = "platformApp.property.create"
        }

        vm.clear = clear;
        vm.save = save;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go('propertyCommercial', null, { reload: 'property' });
        }
        $scope.processEnableChange = function(){
            var arr = vm.property.propertyValues;
            for (var i = arr.length - 1; i >= 0; i--) {
                var item = arr[i];
                if (item.id == null) {
                    arr.splice(i, 1);
                } else {
                    item.cancelled = true;
                }
            }
            if(!vm.property.process){
                vm.property.processOperationId = null
            }
        }
        $scope.processOperationChange = function(){
            var arr = vm.property.propertyValues;
            for (var i = arr.length - 1; i >= 0; i--) {
                var item = arr[i];
                if (item.id == null) {
                    arr.splice(i, 1);
                } else {
                    item.cancelled = true;
                }
            }

            if(vm.property.processOperationId){
                var currentProcess = vm.processOperationList.find(function(item){
                    return item.id == vm.property.processOperationId
                }) || {operationValues:[]}
                currentProcess.operationValues.forEach(function(itm){
                    var value = {id:null,value:itm.alias,cancelled:false,added:true,uuid:UidService.get(),operationValueId:itm.id,spotColor:itm.spotColor,color:itm.color}
                    if (vm.property.propertyValues == null) {
                        vm.property.propertyValues = [];
                    }
                    vm.property.propertyValues.push(value);
                })
            }
            vm.delTableList = []
            vm.showAddBtn = false
        }
        $scope.validate = function(){
            if(vm.property.name == null || vm.property.name==""){
                MessageService.error($filter('translate')('platformApp.property.proNamePlaceholder'));
                return false;
            }
            return true;
        };

        $scope.addValue = function(){
            if(!$scope.validate()){
                return;
            }
            if(vm.showAddBtn){
                var currentProcessOperation = vm.processOperationList.find(function(item){
                    return item.id == vm.property.processOperationId
                }) || {operationValues: []}
                var delTableList = []
                var operationValues = currentProcessOperation.operationValues || []
                var propertyValues = vm.property.propertyValues || []
                operationValues.forEach(function(operationValue){
                    var exists = propertyValues.some(function(propertyValue){
                        return !propertyValue.cancelled && propertyValue.operationValueId == operationValue.id
                    })
                    if (!exists) {
                        var deletedValue = propertyValues.find(function(propertyValue){
                            return propertyValue.cancelled && propertyValue.operationValueId == operationValue.id
                        })
                        if (deletedValue) {
                            delTableList.push(deletedValue)
                        } else {
                            delTableList.push({id:null,value:operationValue.alias,cancelled:false,added:true,uuid:UidService.get(),operationValueId:operationValue.id,spotColor:operationValue.spotColor,color:operationValue.color})
                        }
                    }
                })
                vm.delTableList = delTableList

                $uibModal.open({
                    templateUrl: 'app/entities/property-commercial/add-property-value.html',
                    controller: 'AddPropertyValueController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'mg',
                    resolve: {
                        msgdata: function() {
                            return {
                                delTableList: delTableList
                            }
                        }
                    }
                }).result.then(function(selectedItems){
                    angular.forEach(selectedItems, function(selectedItem) {
                        var found = false;
                        for (var i = 0; i < vm.property.propertyValues.length; i++) {
                            if (vm.property.propertyValues[i].id === selectedItem.id) {
                                vm.property.propertyValues[i].img = '';
                                vm.property.propertyValues[i].cancelled = false;
                                found = true;
                                break;
                            }
                        }
                        if (!found && selectedItem.operationValueId != null) {
                            var currentProcessOperation = vm.processOperationList.find(function(item){
                                return item.id == vm.property.processOperationId
                            }) || {operationValues: []}
                            var operationValues = currentProcessOperation.operationValues || []
                            var matchedOperationValue = operationValues.find(function(operationValue){
                                return operationValue.id == selectedItem.operationValueId
                            })
                            if (matchedOperationValue) {
                                if (vm.property.propertyValues == null) {
                                    vm.property.propertyValues = [];
                                }
                                vm.property.propertyValues.push({
                                    id: null,
                                    value: matchedOperationValue.alias,
                                    cancelled: false,
                                    added: true,
                                    uuid: UidService.get(),
                                    operationValueId: matchedOperationValue.id,
                                    spotColor: matchedOperationValue.spotColor,
                                    color: matchedOperationValue.color
                                });
                            }
                        }
                        for (var j = vm.delTableList.length - 1; j >= 0; j--) {
                            if (vm.delTableList[j].id === selectedItem.id) {
                                vm.delTableList.splice(j, 1);
                                break;
                            }
                        }
                    });
                    if(vm.delTableList.length === 0){
                        vm.showAddBtn = false;
                    }
                });
            }else{
                var value = {id:null,value:null,cancelled:false,added:true,uuid:UidService.get()}
                if (vm.property.propertyValues == null) {
                    vm.property.propertyValues = [];
                }
                vm.property.propertyValues.push(value);
            }
        };

        $scope.deleteValue = function(value){
            if(value == null || vm.property.propertyValues == null || vm.property.propertyValues.length == 0){
                return;
            }
            if(value.id==null){
                var inde1 = vm.property.propertyValues.indexOf(value);
                vm.property.propertyValues.splice(inde1,1);
            }else{
                value.cancelled = true;
            }

            if(vm.property.process && vm.property.processOperationId){
                value.processOperationId = vm.property.processOperationId
                vm.delTableList.push(value)
                vm.showAddBtn = true
            }
        };

        $scope.removeFile2 = function (value) {
            value.img = null;
        };

        window.xmlLineImgFile = function ($event) {
            var file = $event.target.files[0];
            var uploadValue = vm.uploadTarget;
            if (!file || !uploadValue) {
                return;
            }
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "property-" + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    $timeout(function () {
                        var domain = ($scope.domain && $scope.domain !== 'undefined') ? $scope.domain : 'https://' + (vm.domains.domains && vm.domains.domains[0] || '') + '/';
                        uploadValue.img = domain + data.key;
                    });
                },
                error: function (request) {
                    $timeout(function () {
                        MessageService.error($filter('translate')('platformApp.property.fileUploadFail'));
                    });
                }
            });
        };

        $scope.goToReadImage = function (pic) {
            $('body').css("overflow", "hidden");
            $(".origin-image-dialog").removeClass('hide1');
            $(".dialog-form").addClass('opacity-zero');
            $(".origin-image-dialog img").attr('src', pic);
            $(".modal-content,.modal-dialog").addClass('clear-model');
        };

        vm.multilingual = function (data, item,fieldName, index) {
            $uibModal.open({
                templateUrl: 'app/entities/multilingualDialog/multilingualDialog.html',
                controller: 'MultilingualDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass:'modal-multilingual',
                resolve: {
                    entity: [function() {
                        return {
                            data:index>=0 ? vm.property.propertyValues[index][data] : vm.property[data],
                            key: item,
                            fieldValue: index>=0 ? vm.property.propertyValues[index][item] : vm.property[item],
                            fieldName: fieldName
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    if(index>=0){
                        vm.property.propertyValues[index][data] = res;
                    }else{
                        vm.property[data] = res;
                    }
                }
            });
        }


        function save() {
            var isValueNull = false
            for(var i=0;i<vm.property.propertyValues.length;i++){
                var v = vm.property.propertyValues[i];
                if(v.value==null||v.value==''){
                    MessageService.error($filter('translate')('platformApp.property.proValueListPlaceholder'));
                    isValueNull = true
                    break
                }
            }
            if(isValueNull){
                return false;
            }
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if (vm.property.id !== null) {
                Property.update(vm.property, onSaveSuccess, onSaveError);
            } else {
                Property.save(vm.property, onSaveSuccess, onSaveError);
            }
        };

        function onSaveSuccess (res) {
            if(res.status==200){
                $scope.$emit('backApp:propertyUpdate', res.data);
                $state.go('propertyCommercial', null, { reload: 'property' });
                vm.isSaving = false;
                MessageService.success($filter('translate')('platformApp.property.saveSuccess'));
            }else{
                MessageService.error(res.message);
            }

        }

        function onSaveError () {
            MessageService.error($filter('translate')('platformApp.property.saveFail'));
            vm.isSaving = false;
        }


        window.addPropertys=function(event){
            var e = event || window.event;
            if(e && e.keyCode==13){ // enter 键
                var value = {id:null,value:e.target.value,cancelled:false,added:true,uuid:UidService.get()};
                if (vm.property.propertyValues == null) {
                    vm.property.propertyValues = [];
                }
                vm.property.propertyValues.push(value);
                $("#field_value").val('');
            }
        };

    }
})();
